import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

const AttendanceLog = lazy(() => import('../pages/hr/AttendanceLog'));
const LeaveRequests = lazy(() => import('../pages/hr/LeaveRequests'));
const Expenses = lazy(() => import('../pages/hr/Expenses'));

export const hrRoutes = (
  <>
    <Route path="/attendance" element={<ProtectedRoute module="attendance" action="view"><AttendanceLog /></ProtectedRoute>} />
    <Route path="/leave" element={<ProtectedRoute module="leave" action="view"><LeaveRequests /></ProtectedRoute>} />
    <Route path="/expenses" element={<ProtectedRoute module="expenses" action="view"><Expenses /></ProtectedRoute>} />
  </>
);

export default hrRoutes;
